import React, { useContext, useMemo } from 'react';
import { Link, LinkProps, NavLink } from 'react-router-dom';
import { Match } from 'path-to-regexp';

import { isAbsolutePath } from '../util/isAbsolutePath';
import { IMatchType, IRoutesContextType, RoutesContext } from './RoutesWrapper';

// this type should be expanded to handle all the use cases available on the Link component
type ITo = string;
export function convertToLinkValue(routes: IRoutesContextType, to: ITo): ITo {
  if (!routes) return to;
  if (typeof to !== 'string') return to;

  const [path, ...queries] = to.split('?');
  const queryValue = queries.join('?');
  const [toValue, ...hashes] = path.split('#');
  const hashValue = hashes.join('#');

  let matchResult: Match<IMatchType>;
  const matchRoute = Object.keys(routes)
    .map(key => routes[key])
    .find(routeObj => {
      matchResult = routeObj.match?.(toValue);
      return matchResult;
    });

  if (!matchRoute || !matchResult) {
    return to;
  }

  let convertedValue = matchRoute.toPath(matchResult.params);
  if (hashValue) convertedValue = `${convertedValue}#${hashValue}`;
  if (queryValue) convertedValue = `${convertedValue}?${queryValue}`;

  return convertedValue;
}

interface IABLinkProps extends LinkProps {
  to: ITo;
  children?: React.ReactNode;
  isNavLink?: boolean;
}

const ABLink = React.forwardRef<HTMLAnchorElement>(
  ({ to, isNavLink, ...props }: IABLinkProps, ref) => {
    const routes = useContext(RoutesContext);

    const newTo = useMemo<string>(() => convertToLinkValue(routes, to), [routes, to]);

    if (isAbsolutePath(newTo)) {
      return <a ref={ref} href={newTo} {...props} />;
    }

    return isNavLink ? (
      <NavLink ref={ref} to={newTo} {...props} />
    ) : (
      <Link ref={ref} to={newTo} {...props} />
    );
  },
);

export default ABLink;
